
import './App.css';
import { HashRouter, Route, Routes } from "react-router-dom";
import StartScreen from './component/auth/start/StartScreen';
import Login from './component/auth/login/Login';
import AllDevices from './component/devices/allDevices/AllDevices';
import Header from './component/utils/Header';
import AddDevice from './component/devices/addDevice/AddDevice';
import CardDevice from './component/devices/cardDevice/CardDevice';
import UploadFirmware from './component/devices/upload/UploadFirmware';


function App() {

  return (
    <HashRouter>
      <Header />
      <Routes>
        <Route path="/" element={<StartScreen />} />
        <Route path="/login" element={<Login />} />
        <Route path="/devices" element={<AllDevices />} />
        <Route path="/addDevice" element={<AddDevice />} />
        <Route path="/cardDevice" element={<CardDevice />} />
        <Route path="/uploadFirmware" element={<UploadFirmware />} />
      </Routes>
    </HashRouter>
  );
}

export default App;
